import { ReactComponent as AttachmentIcon } from 'assets/icons/attachment_icon.svg'

import { IconStyles } from '../types'
import { AttachmentIconCustom } from './styles'

interface ViewFileProps extends IconStyles {
  onClick?: any
  width?: string
  height?: string
  filter?: boolean
}

const AttachmentFileIcon = ({
  onClick,
  colorIcon,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  height,
  width,
  filter = false
}: ViewFileProps) => {
  return (
    <AttachmentIconCustom
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      cursor={cursor}
      onClick={onClick}
      colorIcon={colorIcon}
      width={width}
      height={height}
      filter={filter}
    >
      <AttachmentIcon />
    </AttachmentIconCustom>
  )
}

export default AttachmentFileIcon
